import {Link, useNavigate} from "react-router-dom";
import {ENTER, USUARIO} from "../../../util";
import logoSidebar from "../../../img/png/logo_sidebar.png";
import React, {useState} from "react";
import {menu} from "../../../config/menu";
import {acoesSetor} from "../../../config/acoes-setor";
import {logado} from "../../../util/usuario-util";
import {IconSearch} from '@tabler/icons-react';
import {Acao} from "../../../tipos/acao";
import {RoleEnum} from "../../../config/enums/role-enum";
import {Usuario} from "../../../tipos/usuario";
import classes from "./menu-lateral.module.css";
import {Center, Divider, Group, Image, NavLink, TextInput, Title} from "@mantine/core";
import {converterCaracteresEspeciaisHifen} from "../../../util/stringUtil";

interface MenuLateralProps {
  setMobile: (value: (((prevState: boolean) => boolean) | boolean)) => void
}

export default function MenuLateral(props: MenuLateralProps) {

  const navegacao = useNavigate()
  const [busca, setBusca] = useState('');
  const [active1, setActive1] = useState('');
  const [active2, setActive2] = useState('');

  const usuario: Usuario = JSON.parse(localStorage.getItem(USUARIO) as string)

  if (!logado()) return <></>;

  function ativarMenu1(index: string) {
    setActive1(index)
  }

  function ativarMenu2(index: string, menuPai: string) {
    setActive1(menuPai)
    setActive2(index)
    props.setMobile(false)
  }

  function getUrl(acao: Acao) {
    if (acao.url) return acao.url;
    return (converterCaracteresEspeciaisHifen(acao.nome) + "/")
  }

  function possuiAcesso(perfis: RoleEnum[], usuario: Usuario) {
    let perfisEncontrados = usuario.authorities.filter(a => perfis.includes(a.role!!));
    return perfisEncontrados.length > 0;
  }

  function buscar(e: any) {
    e.preventDefault()
    if (e.keyCode === ENTER || e._reactName === 'onClick') {
      navegacao(`/busca?q=${busca}`, {replace: false})
    }
  }

  const espacamento = 3

  function menuGeral(): any {
    return menu.map((acao) => {
      if (!acao.acoes) {
        if (acao.perfis && !possuiAcesso(acao.perfis, usuario)) {
          return ""
        }
        return (
          <NavLink
            key={getUrl(acao)}
            component={Link}
            to={'/' + getUrl(acao)}
            label={acao.nome}
            leftSection={<acao.icone size={30} stroke={1.5}/>}
            childrenOffset={28}
            active={getUrl(acao) === active1}
            onClick={() => {
              ativarMenu1(getUrl(acao))
              props.setMobile(false)
            }}
            my={espacamento}
            variant="filled"
            className={classes.link}
          />
        )
      } else {
        return submenu(acao, "", getUrl(acao))
      }
    });
  }

  function submenu(subMenu: Acao, menuPai: string, index: string) {
    if (subMenu.perfis && !possuiAcesso(subMenu.perfis, usuario)) {
      return ''
    }
    return (
      <NavLink
        key={getUrl(subMenu)}
        component={Link}
        to={"#"}
        label={subMenu.nome}
        leftSection={<subMenu.icone size={30} stroke={1.5}/>}
        childrenOffset={28}
        active={active1.includes(getUrl(subMenu))}
        // onClick={() => ativarMenu1(getUrl(subMenu))}
        variant="filled"
        my={espacamento}
        className={classes.link}
      >
        {subMenu.acoes ? subMenu.acoes.map((acao) => {
          if (!acao.acoes) {
            if (acao.perfis && !possuiAcesso(acao.perfis, usuario)) {
              return <div key={Math.random()}></div>
            }
            return (gerarItemMenu(acao, menuPai + getUrl(subMenu), index.toString() + getUrl(acao)))
          } else {
            return submenu(acao, menuPai + getUrl(subMenu), index)
          }
        }) : ""}
      </NavLink>
    )
  }

  function gerarMenuSetor() {
    if (!usuario || !usuario?.setor) return <></>
    return acoesSetor.map((acao) => {
      if (!acao.acoes) {
        return (
          <NavLink
            key={getUrl(acao)}
            component={Link}
            to={'/' + getUrl(acao)}
            label={acao.nome}
            leftSection={<acao.icone size={30} stroke={1.5}/>}
            childrenOffset={28}
            active={getUrl(acao) === active1}
            onClick={() => {
              ativarMenu1(getUrl(acao))
              props.setMobile(false)
            }}
            variant="filled"
            my={espacamento}
            className={classes.link}
          />
        )
      } else {
        return submenu(acao, "", getUrl(acao))
      }
    });
  }

  function gerarItemMenu(acao: Acao, menuPai: string, index: string) {
    return (
      <NavLink
        key={getUrl(acao)}
        component={Link}
        to={'/' + menuPai +'/'+ getUrl(acao)}
        label={acao.nome}
        leftSection={<acao.icone size={25} stroke={1.5}/>}
        active={index === active2}
        onClick={() => ativarMenu2(index, menuPai)}
        variant="filled"
        my={espacamento}
        className={classes.link}
      />
    )
  }

  return (
    <>
      <Center>
        <Link to="/principal">
          <Group>
            <Image src={logoSidebar} alt="Asplan Logo" w={40}/>
            <Title component={"span"} order={3}>ASPLAN</Title>
          </Group>
        </Link>

      </Center>

      <Divider h={5} my={10} w={"100%"} />

      <TextInput
        name="busca"
        autoComplete="off"
        placeholder="Pesquisar"
        rightSection={<IconSearch size={18}/>}
        onKeyUp={buscar}
        onChange={(e) => setBusca(e.currentTarget.value)}
        styles={{
          input: {
            backgroundColor: '#f5f5f5',
          }
        }}
      />

      <Divider h={5} my={10} w={"100%"} />

      <Title order={6}>Menu</Title>

      {gerarMenuSetor()}
      {menuGeral()}
    </>

  );
}
